import React from 'react';
import Method from "../components/Method";
import Attributes from "../components/Attributes";
import Layout from "../layout";

const RateObject = (props) => {
    return (
        <Layout children={props.children} location={props.location}>
            <div className="row">
                <div className="col-md-8">
                    <h1>Maps </h1>
                    <br/>
                    <p>
                        Biteship provide Maps that can help you query specific area, city, or district within the country. This API will help ease your area search for the rates API.
                    </p>
                    <br/>
                    <Method title={"ENDPOINTS"} white>
                        <a href="/docs/api/maps/single_search_area" className="text-decoration-none">
                            <text className="text-black-50"><b className="text-primary">GET</b> /v1/maps/areas </text><br/>
                        </a>
                        <a href="/docs/api/maps/double_search_area" className="text-decoration-none">
                            <text className="text-black-50"><b className="text-primary">GET</b> /v1/maps/areas/:id </text><br/>
                        </a>
                    </Method>
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-md-8">
                    <h2 className="h3">The Area object</h2>
                    <br/>
                    <p>List of all attributes in the area object</p>
                    <Attributes data={attributes}/>
                </div>
            </div>
        </Layout>
    )
};

const attributes = [{
    name:'areas',
    type:'array',
    description:'Origin object',
    items: [
        {
            name:'id',
            type:'string',
            description:'Area id'
        },
        {
            name:'name',
            type:'string',
            description:'Area full name'
        },
        {
            name:'country_name',
            type:'string',
            description:'The country of the area',
        },
        {
            name:'country_code',
            type:'string',
            description:'Two-letter ISO 3166-1 Country Code',
        },
        {
            name:'administrative_division_level_1_name',
            type:'string',
            description:'First-level of administrative division name',
        },
        {
            name:'administrative_division_level_1_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Province' ,
        },
        {
            name:'administrative_division_level_2_name',
            type:'string',
            description:'Second-level of administrative division name',
        },
        {
            name:'administrative_division_level_2_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, City' ,
        },
        {
            name:'administrative_division_level_3_name',
            type:'string',
            description:'Third-level of administrative division name',
        },
        {
            name:'administrative_division_level_3_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, District' ,
        },
        {
            name:'administrative_division_level_4_name',
            type:'string',
            description:'Fourth-level of administrative division name',
        },
        {
            name:'administrative_division_level_4_type',
            type:'string',
            description:'First-level of administrative division type. For Indonesia, Subdistrict' ,
        },
        {
            name:'postal_code',
            type:'integer',
            description:'The postal code of area' ,
        }
    ]
}]

export default RateObject
